module.exports = __webpack_public_path__ + "img/line-icon.8a9378f9.png";